import { HEADING_COLOR, textFromRichHtml, type BlockComponentProps } from "./shared"

export function VolunteerSignupBlock({ content, resolved }: BlockComponentProps) {
  const vh = (content?.heading as string) ?? "Join us as a volunteer"
  const body = textFromRichHtml(content?.body)
  const cta = (content?.cta_text as string) ?? "Sign up to volunteer"
  const volSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass || "text-center"}`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8 text-center"
  return (
    <section
      className={volSectionClass}
      style={{
        ...(resolved.sectionStyle ?? {}),
        background: resolved.sectionStyle?.backgroundColor ?? "var(--nos-color-primary, #3b82f6)",
        color: "#fff",
      }}
    >
      <h2 className="text-2xl font-bold mb-4">{vh}</h2>
      {body && <p className="mb-6 max-w-xl mx-auto">{body}</p>}
      <button type="button" className="px-6 py-3 rounded-lg bg-white font-semibold" style={{ color: HEADING_COLOR }}>
        {cta}
      </button>
    </section>
  )
}
